import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";



import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';


class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.proyectos.config.presupuesto.plazos.edit}
                postUrl={api.proyectos.config.presupuesto.plazos.edit}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                successMessage={"El Plazo ha sido editado con éxito."}
                title={"Editar Plazo"}
                buttonTitle={"Editar Plazo"}
                buttonIcon={"fa fa-pencil fa-lg"}
                
                saveButton={true}
                closeButton={true}>
                <Row>
                    <Col className="col-2">
                        <Label>Nombre</Label>
                    </Col>
                    <Col className="col-10">
                        <Input type="text" name="nombre"></Input>
                        <FormFeedback className="col-12"></FormFeedback>
                    </Col>
                </Row>
            </ParadigmaModal>
        );
    }
}

export default Edit;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_Plazos/Edit.js